import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import momentLocalizer from 'react-widgets/lib/localizers/moment';
import cl from 'classnames';

momentLocalizer(moment);

function renderDatePicker({ input, label, meta: { touched, error, warning }, ...rest }) {
  return (
    <fieldset className={cl('form-group', { 'has-error': (touched && error) })}>
      {label ? <label htmlFor={`form-input-${input.name}`}>{label}</label> : null}
      <DateTimePicker
        id={`form-input-${input.name}`}
        {...input}
        onChange={(_, value) => input.onChange(value)}
        time={false}
        format={'MM/DD/YYYY'}
        onBlur={() => input.onBlur()}
        value={input.value ? moment(input.value, 'MM/DD/YYYY').toDate() : null}
        {...rest}
      />
      {touched && ((error && <div className="error help-block">{error}</div>) || (warning && <div className="error">{warning}</div>))}
    </fieldset>
  );
}

renderDatePicker.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string
  }).isRequired,
  label: PropTypes.string,
  type: PropTypes.string
};

renderDatePicker.defaultProps = {
  label: null,
  type: 'text'
};

export default renderDatePicker;
